import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export const OfflineWatcher = () => {
  const [offline, setOffline] = useState(() => !navigator.onLine);
  useEffect(() => {
    const down = () => setOffline(true);
    const up = () => window.location.reload();
    window.addEventListener("offline", down);
    if (offline) window.addEventListener("online", up);
    return () => { window.removeEventListener("offline", down); window.removeEventListener("online", up); };
  }, [offline]);
  if (!offline) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] flex justify-center p-3 pointer-events-none" data-testid="offline-banner">
      <div className="pointer-events-auto flex items-center gap-2 rounded-full bg-[#050505] text-white text-sm font-semibold px-4 py-2.5 shadow-lg">
        <WifiOff className="w-4 h-4" /> Vous êtes hors ligne — rechargement automatique au retour du réseau
      </div>
    </div>
  );
};
